import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
});

export const nowCombosApi = {
  getAllCombosAdmin: async (kitchenId?: string) => {
    let url = `${API_URL}/api/admin/now-combos`;
    if (kitchenId) {
      url += `?kitchenId=${encodeURIComponent(kitchenId)}`;
    }
    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data;
  },

  createNowCombo: async (data: any) => {
    const response = await axios.post(`${API_URL}/api/admin/now-combos`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  updateNowCombo: async (comboId: string, data: any) => {
    const response = await axios.put(`${API_URL}/api/admin/now-combos/${comboId}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  toggleAvailability: async (comboId: string) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/now-combos/${comboId}/toggle-availability`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  },

  deleteNowCombo: async (comboId: string) => {
    const response = await axios.delete(`${API_URL}/api/admin/now-combos/${comboId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },
};
